// jQuery free
import {onHtmlLayoutReady, requestIdleCallback} from './dom';
import {getCart} from './payload';

const CART_BUTTON_CELL_QUERY_SELECTOR = '.layoutHeaderMainBar__buttonCell.--shoppingCart';

function formatMoney(number, currencyCode, localeTag = null) {
    localeTag = localeTag ?? document.documentElement.lang;

    const numberFormatter = new Intl.NumberFormat(localeTag, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0
    });

    return numberFormatter.format(number,);
}

export const renderCartButton = (cartData = null) => {
    const cart = cartData?.count !== undefined ? cartData : getCart();
    if (!cart) {
        return;
    }

    const buttonCellElements = document.querySelectorAll(CART_BUTTON_CELL_QUERY_SELECTOR);
    if (!buttonCellElements.length) {
        return;
    }

    for (const buttonCellElement of buttonCellElements) {
        const buttonElement = buttonCellElement.getElementsByClassName('layoutHeaderMainBar__button')[0];

        if (!buttonElement) {
            continue;
        }

        if (document.body.classList.contains('--presenter-shoppingcart') && buttonElement.dataset.dropdownId) {
            const id = buttonElement.getAttribute('data-dropdown-id');
            requestAnimationFrame(() => {
                if (window.kvik_removeDropdown) {
                    window.kvik_removeDropdown(id);
                }
            });
        }

        const buttonLabelElement = buttonCellElement.getElementsByClassName('layoutHeaderMainBar__button__label')[0];
        const buttonBadgeElement = buttonCellElement.getElementsByClassName('layoutHeaderMainBar__button__badge')[0];

        if (!buttonLabelElement) {
            continue;
        }

        if (cart.count) {
            const formattedMoney = formatMoney(cart.totalPrice.amountWithVat, cart.totalPrice.currencyCode);
            buttonLabelElement.textContent = `${cart.count} ${buttonCellElement.dataset.labelPieces} / ${formattedMoney}`;
            buttonElement.classList.add('--highlighted');
            if (buttonBadgeElement) {
                buttonBadgeElement.textContent = `${cart.count}`;
            }
        } else {
            buttonLabelElement.textContent = buttonCellElement.dataset.label;
            buttonElement.classList.remove('--highlighted');
            if (buttonBadgeElement) {
                buttonBadgeElement.remove();
            }
        }
    }
};

document.addEventListener('kvik_event_ajax_payload', function () {
    requestIdleCallback(() => renderCartButton());
});

onHtmlLayoutReady(() => renderCartButton());
